export const websiteMetricData = [
  {
    id: '2471',
    channel: 'Amazon',
    users: 575,
    sessions: 9844,
    engagementRate: 70.03,
    engagementTime: '2023-08-04T04:06:11.575Z',
    bounceRate: 34.11,
    chart: [
      {
        label: '1',
        count: 21,
      },
      {
        label: '2',
        count: 23,
      },
      {
        label: '3',
        count: 16,
      },
      {
        label: '4',
        count: 87,
      },
      {
        label: '5',
        count: 49,
      },
      {
        label: '6',
        count: 100,
      },
      {
        label: '7',
        count: 88,
      },
      {
        label: '8',
        count: 57,
      },
      {
        label: '9',
        count: 86,
      },
      {
        label: '10',
        count: 73,
      },
      {
        label: '11',
        count: 57,
      },
      {
        label: '12',
        count: 32,
      },
      {
        label: '13',
        count: 39,
      },
      {
        label: '14',
        count: 99,
      },
      {
        label: '15',
        count: 12,
      },
      {
        label: '16',
        count: 33,
      },
      {
        label: '17',
        count: 26,
      },
      {
        label: '18',
        count: 50,
      },
      {
        label: '19',
        count: 18,
      },
      {
        label: '20',
        count: 48,
      },
    ],
    createdAt: '2023-06-30T19:04:03.521Z',
    updatedAt: '2023-08-16T21:12:20.183Z',
  },
  {
    id: '5459',
    channel: 'Youtube',
    users: 706,
    sessions: 1866,
    engagementRate: 53.95,
    engagementTime: '2023-07-07T05:32:45.711Z',
    bounceRate: 21.19,
    chart: [
      {
        label: '1',
        count: 80,
      },
      {
        label: '2',
        count: 9,
      },
      {
        label: '3',
        count: 59,
      },
      {
        label: '4',
        count: 79,
      },
      {
        label: '5',
        count: 70,
      },
      {
        label: '6',
        count: 4,
      },
      {
        label: '7',
        count: 75,
      },
      {
        label: '8',
        count: 75,
      },
      {
        label: '9',
        count: 89,
      },
      {
        label: '10',
        count: 24,
      },
      {
        label: '11',
        count: 95,
      },
      {
        label: '12',
        count: 7,
      },
      {
        label: '13',
        count: 13,
      },
      {
        label: '14',
        count: 88,
      },
      {
        label: '15',
        count: 10,
      },
      {
        label: '16',
        count: 83,
      },
      {
        label: '17',
        count: 53,
      },
      {
        label: '18',
        count: 73,
      },
      {
        label: '19',
        count: 78,
      },
      {
        label: '20',
        count: 76,
      },
    ],
    createdAt: '2023-07-13T15:28:18.706Z',
    updatedAt: '2023-08-14T21:16:25.388Z',
  },
  {
    id: '7140',
    channel: 'Facebook',
    users: 159,
    sessions: 7611,
    engagementRate: 67.92,
    engagementTime: '2023-07-25T23:51:14.585Z',
    bounceRate: 16.39,
    chart: [
      {
        label: '1',
        count: 26,
      },
      {
        label: '2',
        count: 24,
      },
      {
        label: '3',
        count: 78,
      },
      {
        label: '4',
        count: 82,
      },
      {
        label: '5',
        count: 70,
      },
      {
        label: '6',
        count: 46,
      },
      {
        label: '7',
        count: 10,
      },
      {
        label: '8',
        count: 27,
      },
      {
        label: '9',
        count: 56,
      },
      {
        label: '10',
        count: 49,
      },
      {
        label: '11',
        count: 33,
      },
      {
        label: '12',
        count: 9,
      },
      {
        label: '13',
        count: 58,
      },
      {
        label: '14',
        count: 57,
      },
      {
        label: '15',
        count: 53,
      },
      {
        label: '16',
        count: 57,
      },
      {
        label: '17',
        count: 62,
      },
      {
        label: '18',
        count: 37,
      },
      {
        label: '19',
        count: 48,
      },
      {
        label: '20',
        count: 76,
      },
    ],
    createdAt: '2023-07-03T09:23:41.033Z',
    updatedAt: '2023-08-17T04:56:01.193Z',
  },
  {
    id: '5165',
    channel: 'Direct',
    users: 132,
    sessions: 1917,
    engagementRate: 78.28,
    engagementTime: '2023-08-04T21:30:43.717Z',
    bounceRate: 30.25,
    chart: [
      {
        label: '1',
        count: 17,
      },
      {
        label: '2',
        count: 70,
      },
      {
        label: '3',
        count: 18,
      },
      {
        label: '4',
        count: 34,
      },
      {
        label: '5',
        count: 16,
      },
      {
        label: '6',
        count: 57,
      },
      {
        label: '7',
        count: 24,
      },
      {
        label: '8',
        count: 67,
      },
      {
        label: '9',
        count: 83,
      },
      {
        label: '10',
        count: 18,
      },
      {
        label: '11',
        count: 96,
      },
      {
        label: '12',
        count: 57,
      },
      {
        label: '13',
        count: 34,
      },
      {
        label: '14',
        count: 96,
      },
      {
        label: '15',
        count: 27,
      },
      {
        label: '16',
        count: 25,
      },
      {
        label: '17',
        count: 26,
      },
      {
        label: '18',
        count: 74,
      },
      {
        label: '19',
        count: 49,
      },
      {
        label: '20',
        count: 72,
      },
    ],
    createdAt: '2023-07-27T04:56:27.618Z',
    updatedAt: '2023-08-16T04:16:21.352Z',
  },
  {
    id: '0838',
    channel: 'Facebook',
    users: 2,
    sessions: 7212,
    engagementRate: 16.57,
    engagementTime: '2023-07-26T04:15:02.260Z',
    bounceRate: 41.09,
    chart: [
      {
        label: '1',
        count: 19,
      },
      {
        label: '2',
        count: 47,
      },
      {
        label: '3',
        count: 33,
      },
      {
        label: '4',
        count: 20,
      },
      {
        label: '5',
        count: 21,
      },
      {
        label: '6',
        count: 19,
      },
      {
        label: '7',
        count: 36,
      },
      {
        label: '8',
        count: 20,
      },
      {
        label: '9',
        count: 28,
      },
      {
        label: '10',
        count: 17,
      },
      {
        label: '11',
        count: 64,
      },
      {
        label: '12',
        count: 36,
      },
      {
        label: '13',
        count: 58,
      },
      {
        label: '14',
        count: 76,
      },
      {
        label: '15',
        count: 10,
      },
      {
        label: '16',
        count: 67,
      },
      {
        label: '17',
        count: 73,
      },
      {
        label: '18',
        count: 65,
      },
      {
        label: '19',
        count: 9,
      },
      {
        label: '20',
        count: 84,
      },
    ],
    createdAt: '2023-08-09T22:04:52.630Z',
    updatedAt: '2023-08-14T05:52:51.255Z',
  },
  {
    id: '3104',
    channel: 'Youtube',
    users: 539,
    sessions: 7424,
    engagementRate: 18.98,
    engagementTime: '2023-07-15T11:34:22.272Z',
    bounceRate: 27.01,
    chart: [
      {
        label: '1',
        count: 42,
      },
      {
        label: '2',
        count: 72,
      },
      {
        label: '3',
        count: 47,
      },
      {
        label: '4',
        count: 80,
      },
      {
        label: '5',
        count: 32,
      },
      {
        label: '6',
        count: 55,
      },
      {
        label: '7',
        count: 84,
      },
      {
        label: '8',
        count: 59,
      },
      {
        label: '9',
        count: 42,
      },
      {
        label: '10',
        count: 24,
      },
      {
        label: '11',
        count: 14,
      },
      {
        label: '12',
        count: 61,
      },
      {
        label: '13',
        count: 20,
      },
      {
        label: '14',
        count: 33,
      },
      {
        label: '15',
        count: 40,
      },
      {
        label: '16',
        count: 59,
      },
      {
        label: '17',
        count: 52,
      },
      {
        label: '18',
        count: 20,
      },
      {
        label: '19',
        count: 86,
      },
      {
        label: '20',
        count: 71,
      },
    ],
    createdAt: '2023-07-24T20:03:39.994Z',
    updatedAt: '2023-08-17T10:54:44.902Z',
  },
  {
    id: '3534',
    channel: 'Youtube',
    users: 454,
    sessions: 1620,
    engagementRate: 9.9,
    engagementTime: '2023-06-29T09:00:20.865Z',
    bounceRate: 5.89,
    chart: [
      {
        label: '1',
        count: 94,
      },
      {
        label: '2',
        count: 10,
      },
      {
        label: '3',
        count: 9,
      },
      {
        label: '4',
        count: 64,
      },
      {
        label: '5',
        count: 4,
      },
      {
        label: '6',
        count: 22,
      },
      {
        label: '7',
        count: 42,
      },
      {
        label: '8',
        count: 31,
      },
      {
        label: '9',
        count: 14,
      },
      {
        label: '10',
        count: 27,
      },
      {
        label: '11',
        count: 94,
      },
      {
        label: '12',
        count: 45,
      },
      {
        label: '13',
        count: 22,
      },
      {
        label: '14',
        count: 23,
      },
      {
        label: '15',
        count: 21,
      },
      {
        label: '16',
        count: 62,
      },
      {
        label: '17',
        count: 42,
      },
      {
        label: '18',
        count: 5,
      },
      {
        label: '19',
        count: 74,
      },
      {
        label: '20',
        count: 10,
      },
    ],
    createdAt: '2023-07-11T03:20:08.985Z',
    updatedAt: '2023-08-17T07:34:45.485Z',
  },
  {
    id: '6364',
    channel: 'Facebook',
    users: 673,
    sessions: 5961,
    engagementRate: 42.03,
    engagementTime: '2023-07-05T07:06:58.858Z',
    bounceRate: 2.59,
    chart: [
      {
        label: '1',
        count: 53,
      },
      {
        label: '2',
        count: 36,
      },
      {
        label: '3',
        count: 75,
      },
      {
        label: '4',
        count: 22,
      },
      {
        label: '5',
        count: 36,
      },
      {
        label: '6',
        count: 100,
      },
      {
        label: '7',
        count: 39,
      },
      {
        label: '8',
        count: 17,
      },
      {
        label: '9',
        count: 59,
      },
      {
        label: '10',
        count: 71,
      },
      {
        label: '11',
        count: 70,
      },
      {
        label: '12',
        count: 14,
      },
      {
        label: '13',
        count: 27,
      },
      {
        label: '14',
        count: 11,
      },
      {
        label: '15',
        count: 7,
      },
      {
        label: '16',
        count: 97,
      },
      {
        label: '17',
        count: 5,
      },
      {
        label: '18',
        count: 64,
      },
      {
        label: '19',
        count: 79,
      },
      {
        label: '20',
        count: 71,
      },
    ],
    createdAt: '2023-07-30T08:44:49.418Z',
    updatedAt: '2023-08-16T16:16:23.462Z',
  },
  {
    id: '7831',
    channel: 'Other',
    users: 80,
    sessions: 5361,
    engagementRate: 91.16,
    engagementTime: '2023-08-06T15:09:22.092Z',
    bounceRate: 40.07,
    chart: [
      {
        label: '1',
        count: 31,
      },
      {
        label: '2',
        count: 60,
      },
      {
        label: '3',
        count: 65,
      },
      {
        label: '4',
        count: 94,
      },
      {
        label: '5',
        count: 25,
      },
      {
        label: '6',
        count: 68,
      },
      {
        label: '7',
        count: 7,
      },
      {
        label: '8',
        count: 11,
      },
      {
        label: '9',
        count: 29,
      },
      {
        label: '10',
        count: 19,
      },
      {
        label: '11',
        count: 89,
      },
      {
        label: '12',
        count: 19,
      },
      {
        label: '13',
        count: 15,
      },
      {
        label: '14',
        count: 17,
      },
      {
        label: '15',
        count: 56,
      },
      {
        label: '16',
        count: 76,
      },
      {
        label: '17',
        count: 61,
      },
      {
        label: '18',
        count: 49,
      },
      {
        label: '19',
        count: 64,
      },
      {
        label: '20',
        count: 34,
      },
    ],
    createdAt: '2023-06-30T19:06:57.902Z',
    updatedAt: '2023-08-11T14:59:50.850Z',
  },
  {
    id: '8609',
    channel: 'Instagram',
    users: 215,
    sessions: 6124,
    engagementRate: 18.37,
    engagementTime: '2023-06-24T18:20:26.479Z',
    bounceRate: 21.95,
    chart: [
      {
        label: '1',
        count: 1,
      },
      {
        label: '2',
        count: 18,
      },
      {
        label: '3',
        count: 32,
      },
      {
        label: '4',
        count: 17,
      },
      {
        label: '5',
        count: 14,
      },
      {
        label: '6',
        count: 37,
      },
      {
        label: '7',
        count: 8,
      },
      {
        label: '8',
        count: 68,
      },
      {
        label: '9',
        count: 2,
      },
      {
        label: '10',
        count: 71,
      },
      {
        label: '11',
        count: 79,
      },
      {
        label: '12',
        count: 38,
      },
      {
        label: '13',
        count: 8,
      },
      {
        label: '14',
        count: 48,
      },
      {
        label: '15',
        count: 24,
      },
      {
        label: '16',
        count: 28,
      },
      {
        label: '17',
        count: 65,
      },
      {
        label: '18',
        count: 59,
      },
      {
        label: '19',
        count: 65,
      },
      {
        label: '20',
        count: 6,
      },
    ],
    createdAt: '2023-08-09T16:16:34.947Z',
    updatedAt: '2023-08-14T09:02:20.776Z',
  },
  {
    id: '2501',
    channel: 'Organic Search',
    users: 239,
    sessions: 7059,
    engagementRate: 28.08,
    engagementTime: '2023-07-07T10:26:54.007Z',
    bounceRate: 23,
    chart: [
      {
        label: '1',
        count: 73,
      },
      {
        label: '2',
        count: 1,
      },
      {
        label: '3',
        count: 85,
      },
      {
        label: '4',
        count: 27,
      },
      {
        label: '5',
        count: 41,
      },
      {
        label: '6',
        count: 28,
      },
      {
        label: '7',
        count: 79,
      },
      {
        label: '8',
        count: 31,
      },
      {
        label: '9',
        count: 59,
      },
      {
        label: '10',
        count: 69,
      },
      {
        label: '11',
        count: 25,
      },
      {
        label: '12',
        count: 11,
      },
      {
        label: '13',
        count: 30,
      },
      {
        label: '14',
        count: 75,
      },
      {
        label: '15',
        count: 12,
      },
      {
        label: '16',
        count: 31,
      },
      {
        label: '17',
        count: 87,
      },
      {
        label: '18',
        count: 26,
      },
      {
        label: '19',
        count: 77,
      },
      {
        label: '20',
        count: 98,
      },
    ],
    createdAt: '2023-07-29T21:34:28.917Z',
    updatedAt: '2023-08-15T07:55:55.056Z',
  },
  {
    id: '5631',
    channel: 'AliExpress',
    users: 437,
    sessions: 5863,
    engagementRate: 2.52,
    engagementTime: '2023-07-23T04:32:54.077Z',
    bounceRate: 39.97,
    chart: [
      {
        label: '1',
        count: 39,
      },
      {
        label: '2',
        count: 7,
      },
      {
        label: '3',
        count: 44,
      },
      {
        label: '4',
        count: 100,
      },
      {
        label: '5',
        count: 4,
      },
      {
        label: '6',
        count: 49,
      },
      {
        label: '7',
        count: 19,
      },
      {
        label: '8',
        count: 4,
      },
      {
        label: '9',
        count: 82,
      },
      {
        label: '10',
        count: 93,
      },
      {
        label: '11',
        count: 73,
      },
      {
        label: '12',
        count: 30,
      },
      {
        label: '13',
        count: 12,
      },
      {
        label: '14',
        count: 64,
      },
      {
        label: '15',
        count: 12,
      },
      {
        label: '16',
        count: 85,
      },
      {
        label: '17',
        count: 12,
      },
      {
        label: '18',
        count: 74,
      },
      {
        label: '19',
        count: 0,
      },
      {
        label: '20',
        count: 84,
      },
    ],
    createdAt: '2023-07-27T12:34:45.430Z',
    updatedAt: '2023-08-11T05:14:13.199Z',
  },
  {
    id: '7966',
    channel: 'Email',
    users: 501,
    sessions: 4975,
    engagementRate: 69.6,
    engagementTime: '2023-07-18T19:57:48.986Z',
    bounceRate: 36.18,
    chart: [
      {
        label: '1',
        count: 51,
      },
      {
        label: '2',
        count: 48,
      },
      {
        label: '3',
        count: 79,
      },
      {
        label: '4',
        count: 97,
      },
      {
        label: '5',
        count: 28,
      },
      {
        label: '6',
        count: 82,
      },
      {
        label: '7',
        count: 46,
      },
      {
        label: '8',
        count: 21,
      },
      {
        label: '9',
        count: 21,
      },
      {
        label: '10',
        count: 75,
      },
      {
        label: '11',
        count: 44,
      },
      {
        label: '12',
        count: 17,
      },
      {
        label: '13',
        count: 83,
      },
      {
        label: '14',
        count: 46,
      },
      {
        label: '15',
        count: 63,
      },
      {
        label: '16',
        count: 64,
      },
      {
        label: '17',
        count: 31,
      },
      {
        label: '18',
        count: 72,
      },
      {
        label: '19',
        count: 69,
      },
      {
        label: '20',
        count: 95,
      },
    ],
    createdAt: '2023-06-30T22:00:39.077Z',
    updatedAt: '2023-08-17T09:36:20.370Z',
  },
  {
    id: '0428',
    channel: 'Email',
    users: 272,
    sessions: 1796,
    engagementRate: 39.67,
    engagementTime: '2023-08-18T01:02:51.155Z',
    bounceRate: 13.87,
    chart: [
      {
        label: '1',
        count: 46,
      },
      {
        label: '2',
        count: 60,
      },
      {
        label: '3',
        count: 34,
      },
      {
        label: '4',
        count: 56,
      },
      {
        label: '5',
        count: 47,
      },
      {
        label: '6',
        count: 84,
      },
      {
        label: '7',
        count: 85,
      },
      {
        label: '8',
        count: 24,
      },
      {
        label: '9',
        count: 58,
      },
      {
        label: '10',
        count: 44,
      },
      {
        label: '11',
        count: 9,
      },
      {
        label: '12',
        count: 2,
      },
      {
        label: '13',
        count: 4,
      },
      {
        label: '14',
        count: 49,
      },
      {
        label: '15',
        count: 14,
      },
      {
        label: '16',
        count: 8,
      },
      {
        label: '17',
        count: 82,
      },
      {
        label: '18',
        count: 54,
      },
      {
        label: '19',
        count: 20,
      },
      {
        label: '20',
        count: 86,
      },
    ],
    createdAt: '2023-08-05T09:55:26.224Z',
    updatedAt: '2023-08-16T22:08:39.772Z',
  },
  {
    id: '1422',
    channel: 'Organic Search',
    users: 703,
    sessions: 6068,
    engagementRate: 53.76,
    engagementTime: '2023-07-23T04:13:59.818Z',
    bounceRate: 35.59,
    chart: [
      {
        label: '1',
        count: 21,
      },
      {
        label: '2',
        count: 72,
      },
      {
        label: '3',
        count: 72,
      },
      {
        label: '4',
        count: 27,
      },
      {
        label: '5',
        count: 51,
      },
      {
        label: '6',
        count: 3,
      },
      {
        label: '7',
        count: 96,
      },
      {
        label: '8',
        count: 30,
      },
      {
        label: '9',
        count: 58,
      },
      {
        label: '10',
        count: 83,
      },
      {
        label: '11',
        count: 100,
      },
      {
        label: '12',
        count: 14,
      },
      {
        label: '13',
        count: 67,
      },
      {
        label: '14',
        count: 19,
      },
      {
        label: '15',
        count: 47,
      },
      {
        label: '16',
        count: 87,
      },
      {
        label: '17',
        count: 3,
      },
      {
        label: '18',
        count: 42,
      },
      {
        label: '19',
        count: 53,
      },
      {
        label: '20',
        count: 62,
      },
    ],
    createdAt: '2023-08-02T05:44:37.201Z',
    updatedAt: '2023-08-11T06:54:54.713Z',
  },
  {
    id: '4834',
    channel: 'Referral',
    users: 243,
    sessions: 6290,
    engagementRate: 59.92,
    engagementTime: '2023-07-16T16:22:45.804Z',
    bounceRate: 33.59,
    chart: [
      {
        label: '1',
        count: 4,
      },
      {
        label: '2',
        count: 6,
      },
      {
        label: '3',
        count: 65,
      },
      {
        label: '4',
        count: 50,
      },
      {
        label: '5',
        count: 6,
      },
      {
        label: '6',
        count: 48,
      },
      {
        label: '7',
        count: 61,
      },
      {
        label: '8',
        count: 17,
      },
      {
        label: '9',
        count: 17,
      },
      {
        label: '10',
        count: 6,
      },
      {
        label: '11',
        count: 65,
      },
      {
        label: '12',
        count: 33,
      },
      {
        label: '13',
        count: 9,
      },
      {
        label: '14',
        count: 16,
      },
      {
        label: '15',
        count: 10,
      },
      {
        label: '16',
        count: 51,
      },
      {
        label: '17',
        count: 37,
      },
      {
        label: '18',
        count: 59,
      },
      {
        label: '19',
        count: 78,
      },
      {
        label: '20',
        count: 47,
      },
    ],
    createdAt: '2023-08-15T22:53:20.816Z',
    updatedAt: '2023-08-13T03:57:26.951Z',
  },
  {
    id: '8037',
    channel: 'REDQ',
    users: 345,
    sessions: 9059,
    engagementRate: 6.04,
    engagementTime: '2023-07-25T02:45:46.953Z',
    bounceRate: 12.76,
    chart: [
      {
        label: '1',
        count: 54,
      },
      {
        label: '2',
        count: 54,
      },
      {
        label: '3',
        count: 59,
      },
      {
        label: '4',
        count: 15,
      },
      {
        label: '5',
        count: 8,
      },
      {
        label: '6',
        count: 10,
      },
      {
        label: '7',
        count: 29,
      },
      {
        label: '8',
        count: 5,
      },
      {
        label: '9',
        count: 25,
      },
      {
        label: '10',
        count: 37,
      },
      {
        label: '11',
        count: 79,
      },
      {
        label: '12',
        count: 78,
      },
      {
        label: '13',
        count: 42,
      },
      {
        label: '14',
        count: 44,
      },
      {
        label: '15',
        count: 18,
      },
      {
        label: '16',
        count: 66,
      },
      {
        label: '17',
        count: 51,
      },
      {
        label: '18',
        count: 8,
      },
      {
        label: '19',
        count: 14,
      },
      {
        label: '20',
        count: 7,
      },
    ],
    createdAt: '2023-08-05T13:37:19.696Z',
    updatedAt: '2023-08-11T12:40:46.979Z',
  },
];
